import config from 'environment'

import { PlaytesterV2State } from 'app-redux/playtesterV2/types'

export function getDeviceSpecificDefaults(): Partial<PlaytesterV2State> {
  const defaults: Partial<PlaytesterV2State> = {}

  if (typeof document === 'undefined') return defaults

  const screenWidth = document.body.clientWidth

  // if (config.getIOSSafari()) defaults.defaultActionOnClick = false // No longer needed since we can allow long pressing now - we'll have to see how this goes for users ...

  if (screenWidth < 1400) {
    defaults.manualHandSize = 'small'
    defaults.manualCardSize = 'small'
    defaults.handRotation = false
  }

  if (screenWidth < 600) {
    defaults.fancyZoneClickOpensMenu = true
  }

  return defaults
}
